exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".conditions-header[data-v-bc571aaa] {\n  font-size: 1.5rem;\n  position: relative;\n  top: 18px;\n}\n", ""]);

